export const POST_LOADER = "POST_LOADER";
export const SET_POST = "SET_POST";
export const UNSET_POST = "UNSET_POST";
export const CLOSE_POST_LOADER = "CLOSE_POST_LOADER";
export const SET_SHARE_POST = "SET_SHARE_POST";
export const SET_SHARE_POST_ID = "SET_SHARE_POST_ID";
